// extracted by mini-css-extract-plugin
export default {"Banner":"ProjectInformationBanner_Banner__GnJKn"};